import axios from '../request/http.js'

class Approval {
  /* 流程详情 */
  static getDetails(type, typeId, formId) {
    let url = `/zzd/api/back/approve/setting/list?type=${type}&typeId=${typeId}&formId=${formId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增流程 */
  static postAddApproval(data) {
    let url = `/zzd/api/back/approve/setting/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 修改流程 */
  static postModApproval(data) {
    let url = `/zzd/api/back/approve/setting/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取所有角色成员 */
  static postAllRoleStaff(roleType, name) {
    let url = `/zzd/api/back/biz/role/user/list/role/type?roleType=${roleType}&name=${name}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 根据4级获取其3级下所有角色用户 */
  // static postThirdAllRoleStaff(roleType, deptId) {
  //   let url = `/zzd/api/back/biz/role/list/forth/role/user/by/third/dept?roleType=${roleType}&deptId=${deptId}`
  //   return axios.get(url).then((res) => {
  //     return Promise.resolve(res.data)
  //   })
  // }
  /* 根据部门id角色类型获取对应的角色用户 */
  static postIdAllRoleStaff(roleType, deptId, searchFlag) {
    let url = `/zzd/api/back/biz/role/list/user/by/dept/roleType?roleType=${roleType}&deptId=${deptId}&searchFlag=${searchFlag}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增出差审批单流程 */
  static postAddEvectionApproval(data) {
    let url = `/zzd/api/back/order/pre/trip/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑出差审批单流程 */
  static postModEvectionApproval(data) {
    let url = `/zzd/api/back/order/pre/trip/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取出差审批单详情 */
  static getEvectionDetails() {
    let url = `/zzd/api/back/order/pre/trip/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除流程 */
  static postDelProcedure(data) {
    let url = `/zzd/api/back/approve/setting/delete`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Approval